import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import ModalStyle from "@/styles/components/modal/add-assessment/_index.module.scss";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import Button from "@/components/button";
import {
  FormikControl,
  Formik,
  Form,
  useRef,
} from "@/imports-files/common/common";
import {
  MANAGE_ASSESSMENT,
  InputError,
  setAssessmentInitial,
  useState,
  AssessmentDropZone,
  CustomToastrAction,
} from "@/imports-files/pages/clients/recruitments/manage-assessment";

export function AddAssessment(props) {
  const formRef = useRef(null);
  const customToastrAction = new CustomToastrAction();

  const [uploadFileText, setUploadFileText] = useState(
    props.assessmentAction == "edit" && props.currentRow.file_type == "file"
      ? "Change file"
      : "Upload a file"
  );
  return (
    <div className={`${FormModalStyle.ModalOverlay} AddAssessment`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container} removeplaceholder`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => props.setAssessmentCreateModal({ state: false })}
          >
            <Close/>
            CLOSE
          </div>
          <div className={FormModalStyle.Modal__Container__ContentSection}>
            <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              {props.assessmentAction == "create"
                ? MANAGE_ASSESSMENT.assessmentForm.texts.add_heading
                : MANAGE_ASSESSMENT.assessmentForm.texts.edit_heading}
            </h1>
            <div
              className={
                FormModalStyle.Modal__Container__ContentSection__Description
              }
            >
              Create a new assessment for your candidates by adding a link to
              your online assessment or uploading a file
            </div>
            <Formik
              initialValues={setAssessmentInitial(
                props.assessmentAction,
                props.currentRow
              )}
              innerRef={formRef}
              validationSchema={MANAGE_ASSESSMENT.assessment_validation}
              onSubmit={async (values, actions) => {
                if (props.assessmentAction == "create") {
                  let errors =
                    await props.manageAssessmentAction.createAssessment(
                      values,
                      props.setAssessmentCreateModal,
                      props.setAssessmentList
                    );
                  actions.setErrors(errors);
                } else {
                  let errors =
                    await props.manageAssessmentAction.updateAssessment(
                      values,
                      props.setAssessmentCreateModal,
                      props.setAssessmentList
                    );
                  actions.setErrors(errors);
                }
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      Enter assessment name
                    </label>
                    <FormikControl
                      className={` ${FormModalStyle.Form__Input} `}
                      errorClass={FormModalStyle.Form__Error}
                      control="input"
                      placeholder=""
                      type="text"
                      formik={formik}
                      name="name"
                      style={InputError(formik, "name")}
                      // errorClass={`customError`}
                      custom_class={"form_custom_error"}
                    />
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      Enter assessment link
                    </label>
                    <FormikControl
                      className={` ${FormModalStyle.Form__Input}`}
                      errorClass={FormModalStyle.Form__Error}
                      control="input"
                      placeholder={""}
                      type="text"
                      formik={formik}
                      name="link"
                      disabled={false}
                      style={InputError(formik, "link")}
                      // errorClass={`customError`}
                      custom_class={"form_custom_error"}
                      onChange={(event) => {
                        if (
                          event.target.value.length == 0 &&
                          formik.values.file
                        ) {
                          formik.setFieldValue("file_type", "file");
                        } else {
                          formik.setFieldValue("file_type", "link");
                        }
                        formik.setFieldValue("link", event.target.value);
                      }}
                    />
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Divider}`}
                  >
                    Or
                  </div>
                  <div
                    className={`UploadAssessment ${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      Upload an assessment
                    </label>
                    <span
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Label}`}
                    >
                      Supported files are .doc, .docx, .pdf
                    </span>
                    <div
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__DropboxContainer}`}
                    >
                      <AssessmentDropZone
                        id="upload_assessment"
                        type={"settings"}
                        name={"file"}
                        multiple={false}
                        formRef={formRef}
                        formik={formik}
                        autofill={false}
                        accept={".pdf, .docx, .doc"}
                        dropAction={props.manageAssessmentAction}
                        drop_type={"template"}
                      />
                    </div>
                  </div>
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={`${FormModalStyle.primarybtn}`}
                      type="button"
                      onClick={async (event) => {
                        if (
                          Object.keys(formik.touched).length == 0 &&
                          !formik.values.id
                        ) {
                          formik.submitForm();
                        } else {
                          if (
                            (formik.values.link.length > 0 &&
                              (formik.values.file ||
                                formik.values.filename.length > 0)) ||
                            (formik.values.link.length == 0 &&
                              !formik.values.file &&
                              !(formik.values.filename.length > 0))
                          ) {
                            customToastrAction.setNormalToastr(
                              "Add only assessment link or a file.",
                              "warning"
                            );
                          } else {
                            formik.submitForm();
                          }
                        }
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
